(() => {
  const preloaded = new Set();

  function preload(src) {
    return new Promise((resolve) => {
      if (!src) return resolve();
      if (preloaded.has(src)) return resolve();

      const im = new Image();
      im.onload = () => {
        preloaded.add(src);
        resolve();
      };
      im.onerror = () => resolve();
      im.src = src;
    });
  }

  function preloadBatch(images) {
  images.forEach((img) => {
    if (img?.type === "video") return;

    const src = img?.src;
    if (!src || preloaded.has(src)) return;

    const im = new Image();
    im.onload = () => preloaded.add(src);
    im.onerror = () => {};
    im.src = src;
  });
}

  function ensureStyles() {
    if (document.getElementById("vmfg-styles")) return;
const style = document.createElement("style");
style.id = "vmfg-styles";
style.textContent = `
.vmfg {
  width: 100%;
}

.vmfg-main {
  position: relative;
  width: 100%;
  overflow: hidden;
  touch-action: pan-y;
  user-select: none;
  -webkit-user-select: none;
}

.vmfg-track {
  display: flex;
  width: 100%;
  transition: transform 0.28s ease;
  will-change: transform;
}

.vmfg-main.is-dragging .vmfg-track {
  transition: none;
}

.vmfg-slide {
  min-width: 100%;
  width: 100%;
  flex: 0 0 100%;
  display: flex;
  align-items: stretch;
  justify-content: center;
}

.vmfg-frame {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0;
}

.vmfg-image-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  max-height: 100%;
}

.vmfg-main-img {
  display: block;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  pointer-events: auto;
  user-select: none;
  -webkit-user-drag: none;
  color: transparent;
}

.vmfg-zoom-icon {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 3;
  width: 36px;
  height: 36px;
  border-radius: 999px;
  background: #ffffff;
  color: #111;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.vmfg-zoom-icon svg {
  width: 16px;
  height: 16px;
}

.vmfg-thumbs {
  display: flex;
  gap: 10px;
  margin-top: 12px;
  flex-wrap: wrap;
}

.vmfg-thumb {
  border: 2px solid transparent;
  background: transparent;
  padding: 0;
  cursor: pointer;
  border-radius: 6px;
  overflow: hidden;
}

.vmfg-thumb img {
  display: block;
  width: 72px;
  height: 72px;
  object-fit: cover;
}

.vmfg-thumb.is-active {
  border-color: rgba(18, 18, 18, 1);
}

.vmfg-main-video {
  display: block;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  background: #000;
}

.vmfg-video-thumb {
  width: 72px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #111;
  color: #fff;
}

.vmfg-video-play {
  font-size: 24px;
  line-height: 1;
}

@media (max-width: 749px) {
  .vmfg-video-thumb {
    width: 60px;
    height: 60px;
  }
}

@media (max-width: 749px) {
  .vmfg-thumb img {
    width: 60px;
    height: 60px;
  }
}
  #vmfg-zoom-layer {
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.98);
  z-index: 99999;
  display: none;
  overflow: hidden;
}

#vmfg-zoom-layer.active {
  display: block;
}

#vmfg-zoom-close {
  position: fixed;
  top: 18px;
  right: 18px;
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 999px;
  background: #fff;
  color: #111;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  z-index: 100000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
}

#vmfg-zoom-stage {
  position: absolute;
  inset: 0;
  overflow: hidden;
  cursor: grab;
  touch-action: none;
}

#vmfg-zoom-stage.is-dragging {
  cursor: grabbing;
}

#vmfg-zoom-img {
  position: absolute;
  top: 0;
  left: 0;
  max-width: none;
  width: auto;
  height: auto;
  transform-origin: top left;
  user-select: none;
  -webkit-user-drag: none;
  pointer-events: none;
}
`;
document.head.appendChild(style);
   
  }

  function ensureZoomLayer() {
    let zoomLayer = document.getElementById("vmfg-zoom-layer");
    if (zoomLayer) return zoomLayer;

    zoomLayer = document.createElement("div");
    zoomLayer.id = "vmfg-zoom-layer";
    zoomLayer.setAttribute("aria-hidden", "true");
    zoomLayer.innerHTML = `
      <button id="vmfg-zoom-close" type="button" aria-label="Close zoom">✕</button>
      <div id="vmfg-zoom-stage">
        <img id="vmfg-zoom-img" src="" alt="">
      </div>
    `;

    document.body.appendChild(zoomLayer);
    return zoomLayer;
  }

  function setupVmfgZoom() {
    const zoomLayer = ensureZoomLayer();
    const zoomClose = zoomLayer.querySelector("#vmfg-zoom-close");
    const zoomStage = zoomLayer.querySelector("#vmfg-zoom-stage");
    const zoomImg = zoomLayer.querySelector("#vmfg-zoom-img");

    if (!zoomClose || !zoomStage || !zoomImg) return;

    let scale = 2;
    let maxX = 0;
    let maxY = 0;

    let currentX = 0;
    let currentY = 0;
    let targetX = 0;
    let targetY = 0;

    let dragging = false;
    let dragStartX = 0;
    let dragStartY = 0;
    let startPanX = 0;
    let startPanY = 0;

    let velocityX = 0;
    let velocityY = 0;
    let lastMoveTime = 0;
    let lastClientX = 0;
    let lastClientY = 0;

    let rafId = null;
    let inertiaId = null;
    let suppressClickUntil = 0;

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function updateTransform() {
      zoomImg.style.transform = `translate(${-currentX}px, ${-currentY}px) scale(${scale})`;
    }

    function renderSmooth() {
      currentX += (targetX - currentX) * 0.18;
      currentY += (targetY - currentY) * 0.18;

      if (Math.abs(targetX - currentX) < 0.2) currentX = targetX;
      if (Math.abs(targetY - currentY) < 0.2) currentY = targetY;

      updateTransform();

      if (
        dragging ||
        Math.abs(targetX - currentX) > 0.2 ||
        Math.abs(targetY - currentY) > 0.2
      ) {
        rafId = requestAnimationFrame(renderSmooth);
      } else {
        rafId = null;
      }
    }

    function startSmoothLoop() {
      if (!rafId) rafId = requestAnimationFrame(renderSmooth);
    }

    function stopInertia() {
      if (inertiaId) {
        cancelAnimationFrame(inertiaId);
        inertiaId = null;
      }
    }

    function runInertia() {
      stopInertia();

      function step() {
        velocityX *= 0.94;
        velocityY *= 0.94;

        targetX = clamp(targetX - velocityX, 0, maxX);
        targetY = clamp(targetY - velocityY, 0, maxY);

        startSmoothLoop();

        if (Math.abs(velocityX) > 0.2 || Math.abs(velocityY) > 0.2) {
          inertiaId = requestAnimationFrame(step);
        } else {
          inertiaId = null;
        }
      }

      inertiaId = requestAnimationFrame(step);
    }

    function recalcBounds() {
      const stageWidth = zoomStage.clientWidth;
      const stageHeight = zoomStage.clientHeight;
      const imgWidth = zoomImg.naturalWidth;
      const imgHeight = zoomImg.naturalHeight;

      maxX = Math.max(0, imgWidth * scale - stageWidth);
      maxY = Math.max(0, imgHeight * scale - stageHeight);

      currentX = clamp(currentX, 0, maxX);
      currentY = clamp(currentY, 0, maxY);
      targetX = clamp(targetX, 0, maxX);
      targetY = clamp(targetY, 0, maxY);

      updateTransform();
    }

    function fitImageToViewport() {
      const vw = zoomStage.clientWidth;
      const vh = zoomStage.clientHeight;
      const iw = zoomImg.naturalWidth;
      const ih = zoomImg.naturalHeight;

      if (!iw || !ih) return;

      const fitScale = Math.min(vw / iw, vh / ih);
      zoomImg.style.width = `${iw}px`;
      zoomImg.style.height = `${ih}px`;

      scale = Math.max(2, 1 / fitScale);
      recalcBounds();

      currentX = maxX / 2;
      currentY = maxY / 2;
      targetX = currentX;
      targetY = currentY;
      updateTransform();
    }

    function openZoom(src, alt) {
      stopInertia();
      zoomImg.src = src;
      zoomImg.alt = alt || "";
      zoomLayer.classList.add("active");
      zoomLayer.setAttribute("aria-hidden", "false");
      document.documentElement.style.overflow = "hidden";
    }

    function closeZoom() {
      stopInertia();
      zoomLayer.classList.remove("active");
      zoomLayer.setAttribute("aria-hidden", "true");
      zoomImg.src = "";
      document.documentElement.style.overflow = "";
      dragging = false;
      zoomStage.classList.remove("is-dragging");
    }

    function hoverPan(clientX, clientY) {
      const rect = zoomStage.getBoundingClientRect();
      const px = clamp(clientX - rect.left, 0, rect.width);
      const py = clamp(clientY - rect.top, 0, rect.height);

      const xRatio = rect.width ? px / rect.width : 0.5;
      const yRatio = rect.height ? py / rect.height : 0.5;

      targetX = maxX * xRatio;
      targetY = maxY * yRatio;
      startSmoothLoop();
    }

    document.addEventListener("click", (e) => {
      if (Date.now() < suppressClickUntil) return;

      const trigger = e.target.closest(".vmfg-main-img, .vmfg-zoom-icon");
      if (!trigger) return;

      const frame = trigger.closest(".vmfg-frame");
      const img = frame ? frame.querySelector(".vmfg-main-img") : null;
      if (!img) return;

      openZoom(img.currentSrc || img.src, img.alt || "");
    });

    zoomImg.addEventListener("load", fitImageToViewport);
    zoomClose.addEventListener("click", closeZoom);

    zoomStage.addEventListener("mousemove", (e) => {
      if (!zoomLayer.classList.contains("active")) return;
      if (dragging) return;
      hoverPan(e.clientX, e.clientY);
    });

    zoomStage.addEventListener("mousedown", (e) => {
      dragging = true;
      stopInertia();
      dragStartX = e.clientX;
      dragStartY = e.clientY;
      startPanX = targetX;
      startPanY = targetY;
      lastClientX = e.clientX;
      lastClientY = e.clientY;
      lastMoveTime = performance.now();
      velocityX = 0;
      velocityY = 0;
      zoomStage.classList.add("is-dragging");
    });

    window.addEventListener("mousemove", (e) => {
      if (!dragging) return;

      const now = performance.now();
      const dt = Math.max(16, now - lastMoveTime);

      const dx = e.clientX - dragStartX;
      const dy = e.clientY - dragStartY;

      targetX = clamp(startPanX - dx, 0, maxX);
      targetY = clamp(startPanY - dy, 0, maxY);
      startSmoothLoop();

      velocityX = ((e.clientX - lastClientX) / dt) * 16;
      velocityY = ((e.clientY - lastClientY) / dt) * 16;

      lastClientX = e.clientX;
      lastClientY = e.clientY;
      lastMoveTime = now;
    });

    window.addEventListener("mouseup", () => {
      if (!dragging) return;
      dragging = false;
      zoomStage.classList.remove("is-dragging");
      runInertia();
    });

    zoomStage.addEventListener("touchstart", (e) => {
      if (!e.touches.length) return;
      dragging = true;
      stopInertia();
      const t = e.touches[0];
      dragStartX = t.clientX;
      dragStartY = t.clientY;
      startPanX = targetX;
      startPanY = targetY;
      lastClientX = t.clientX;
      lastClientY = t.clientY;
      lastMoveTime = performance.now();
      velocityX = 0;
      velocityY = 0;
      zoomStage.classList.add("is-dragging");
    }, { passive: true });

    zoomStage.addEventListener("touchmove", (e) => {
      if (!dragging || !e.touches.length) return;

      const t = e.touches[0];
      const now = performance.now();
      const dt = Math.max(16, now - lastMoveTime);

      const dx = t.clientX - dragStartX;
      const dy = t.clientY - dragStartY;

      targetX = clamp(startPanX - dx, 0, maxX);
      targetY = clamp(startPanY - dy, 0, maxY);
      startSmoothLoop();

      velocityX = ((t.clientX - lastClientX) / dt) * 16;
      velocityY = ((t.clientY - lastClientY) / dt) * 16;

      lastClientX = t.clientX;
      lastClientY = t.clientY;
      lastMoveTime = now;
    }, { passive: true });

    zoomStage.addEventListener("touchend", () => {
      if (!dragging) return;
      dragging = false;
      zoomStage.classList.remove("is-dragging");
      runInertia();
      suppressClickUntil = Date.now() + 250;
    });

    window.addEventListener("resize", () => {
      if (!zoomLayer.classList.contains("active")) return;
      fitImageToViewport();
    });
  }

  function init(sectionEl) {
        const mapEl = sectionEl.querySelector('[id^="VariantGalleryMap-"]');
    if (!mapEl) return;

    let map = {};
    try {
      map = JSON.parse(mapEl.dataset.variantGallery || "{}");
    } catch (e) {
      console.warn("Variant metafield gallery JSON invalid", e);
      return;
    }

    const mediaWrapper = sectionEl.querySelector(".product__media-wrapper");
    if (!mediaWrapper) return;

    const originalHTML = mediaWrapper.innerHTML;
    sectionEl.classList.remove("vmfg-ready");

    let didInit = false;
    let currentIndex = 0;
    let activeVariantId = null;

    ensureStyles();

    function getVariantId() {
      const input = sectionEl.querySelector('form[action^="/cart/add"] input[name="id"]');
      return input ? input.value : null;
    }

    function escapeHtml(value) {
      return String(value || "")
        .replace(/&/g, "&amp;")
        .replace(/"/g, "&quot;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    }

    function buildHTML(images, activeIndex) {
      const slides = images
  .map((img, i) => {
    if (img.type === "video") {
      return `
        <div class="vmfg-slide" data-index="${i}">
          <div class="vmfg-frame">
            <div class="vmfg-image-wrap">
              <video
                class="vmfg-main-video"
                controls
                playsinline
                preload="metadata"
              >
                <source src="${img.src}" type="video/mp4">
              </video>
            </div>
          </div>
        </div>
      `;
    }

    return `
      <div class="vmfg-slide" data-index="${i}">
        <div class="vmfg-frame">
          <div class="vmfg-image-wrap">
            <span class="vmfg-zoom-icon" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-zoom" viewBox="0 0 18 18">
                <path fill="currentColor" d="m11 13.164 4.5 4.5 1.164-1.164-4.5-4.5zM3.5 8a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2"/>
                <path fill="currentColor" d="M8.75 5.75h-1.5v1.5h-1.5v1.5h1.5v1.5h1.5v-1.5h1.5v-1.5h-1.5z"/>
              </svg>
            </span>

            <img
              class="vmfg-main-img"
              src="${img.src}"
              alt="${escapeHtml(img.alt || "")}"
              loading="${i === activeIndex ? "eager" : "lazy"}"
              ${i === activeIndex ? 'fetchpriority="high" decoding="async"' : ""}
            >
          </div>
        </div>
      </div>
    `;
  })
  .join("");

      const thumbs = images
  .map((img, i) => {
    if (img.type === "video") {
      return `
        <button
          type="button"
          class="vmfg-thumb vmfg-video-thumb ${i === activeIndex ? "is-active" : ""}"
          data-index="${i}"
          aria-label="Play product video"
        >
          <span class="vmfg-video-play" aria-hidden="true">▶</span>
        </button>
      `;
    }

    return `
      <button
        type="button"
        class="vmfg-thumb ${i === activeIndex ? "is-active" : ""}"
        data-index="${i}"
        aria-label="Show image ${i + 1}"
      >
        <img
          src="${img.thumb || img.src}"
          loading="lazy"
          alt="${escapeHtml(img.alt || "")}"
        >
      </button>
    `;
  })
  .join("");

      return `
        <div class="vmfg">
          <div class="vmfg-main">
            <div class="vmfg-track" style="transform: translateX(-${activeIndex * 100}%);">
              ${slides}
            </div>
          </div>
          <div class="vmfg-thumbs">${thumbs}</div>
        </div>
      `;
    }

    function bindGallery(images) {
      const main = mediaWrapper.querySelector(".vmfg-main");
      const track = mediaWrapper.querySelector(".vmfg-track");
      const thumbs = Array.from(mediaWrapper.querySelectorAll(".vmfg-thumb"));

      if (!main || !track) return;

      let startX = 0;
      let currentTranslate = 0;
      let prevTranslate = 0;
      let dragging = false;

      function clampIndex(index) {
        if (index < 0) return 0;
        if (index > images.length - 1) return images.length - 1;
        return index;
      }

      function updateThumbs() {
        thumbs.forEach((thumb, i) => {
          thumb.classList.toggle("is-active", i === currentIndex);
        });
      }

      function setSlide(index, animate = true) {
  mediaWrapper.querySelectorAll(".vmfg-main-video").forEach((video) => {
    video.pause();
  });

  currentIndex = clampIndex(index);
  track.style.transition = animate ? "transform 0.28s ease" : "none";
  track.style.transform = `translateX(-${currentIndex * 100}%)`;
  updateThumbs();
}

      thumbs.forEach((btn) => {
        btn.addEventListener("click", async () => {
          const idx = parseInt(btn.dataset.index, 10);
          if (Number.isNaN(idx) || !images[idx]) return;

          if (images[idx].type !== "video") {
  await preload(images[idx].src);
}

setSlide(idx, true);
        });
      });

      function getClientX(e) {
        if (e.touches && e.touches.length) return e.touches[0].clientX;
        if (e.changedTouches && e.changedTouches.length) return e.changedTouches[0].clientX;
        return e.clientX;
      }

      function dragStart(e) {
        if (images.length <= 1) return;
        dragging = true;
        main.classList.add("is-dragging");
        startX = getClientX(e);
        prevTranslate = -currentIndex * main.offsetWidth;
        currentTranslate = prevTranslate;
      }

      function dragMove(e) {
        if (!dragging) return;
        const currentX = getClientX(e);
        const diff = currentX - startX;
        currentTranslate = prevTranslate + diff;
        track.style.transform = `translateX(${currentTranslate}px)`;
      }

      function dragEnd() {
        if (!dragging) return;
        dragging = false;
        main.classList.remove("is-dragging");

        const movedBy = currentTranslate - prevTranslate;
        const threshold = main.offsetWidth * 0.15;

        if (movedBy < -threshold) {
          currentIndex = clampIndex(currentIndex + 1);
        } else if (movedBy > threshold) {
          currentIndex = clampIndex(currentIndex - 1);
        }

        setSlide(currentIndex, true);
      }

      main.addEventListener("touchstart", dragStart, { passive: true });
      main.addEventListener("touchmove", dragMove, { passive: true });
      main.addEventListener("touchend", dragEnd);
      main.addEventListener("touchcancel", dragEnd);

      main.addEventListener("mousedown", (e) => {
        e.preventDefault();
        dragStart(e);
      });

      window.addEventListener("mousemove", dragMove);
      window.addEventListener("mouseup", dragEnd);

      window.addEventListener("resize", () => {
        setSlide(currentIndex, false);
      });

      preloadBatch(images.slice(1));
      setSlide(currentIndex, false);
    }

    async function render(variantId) {
  const galleryStart = performance.now();

  const variantKey = String(variantId);
  const shouldScroll = didInit;
  didInit = true;

  console.log(
    "[VMFG] render started:",
    Math.round(performance.now() - galleryStart),
    "ms"
  );

  if (activeVariantId === variantKey) return;
  activeVariantId = variantKey;

  const imgs = (map[variantKey] || []).filter(Boolean);

  console.log(
    "[VMFG] image map ready:",
    Math.round(performance.now() - galleryStart),
    "ms",
    "images:",
    imgs.length
  );

  if (!imgs.length) {
    mediaWrapper.innerHTML = originalHTML;
    sectionEl.classList.add("vmfg-ready");
    return;
  }

  currentIndex = 0;
  sectionEl.classList.remove("vmfg-ready");

  const preloadStart = performance.now();

  await preload(imgs[0]?.src);

  console.log(
    "[VMFG] first image preload finished:",
    Math.round(performance.now() - preloadStart),
    "ms",
    "| total:",
    Math.round(performance.now() - galleryStart),
    "ms"
  );

  if (activeVariantId !== variantKey) return;

  const buildStart = performance.now();

  const temp = document.createElement("div");
  temp.innerHTML = buildHTML(imgs, currentIndex);

  console.log(
    "[VMFG] gallery HTML built:",
    Math.round(performance.now() - buildStart),
    "ms",
    "| total:",
    Math.round(performance.now() - galleryStart),
    "ms"
  );

  const nextMainImg = temp.querySelector(".vmfg-main-img");

  const imageReadyStart = performance.now();

  if (nextMainImg && !nextMainImg.complete) {
    await new Promise((resolve) => {
      nextMainImg.onload = resolve;
      nextMainImg.onerror = resolve;
    });
  }

  console.log(
    "[VMFG] temporary image ready:",
    Math.round(performance.now() - imageReadyStart),
    "ms",
    "| total:",
    Math.round(performance.now() - galleryStart),
    "ms"
  );

  const insertStart = performance.now();

  mediaWrapper.innerHTML = temp.innerHTML;
  bindGallery(imgs);
  sectionEl.classList.add("vmfg-ready");

  console.log(
    "[VMFG] gallery inserted:",
    Math.round(performance.now() - insertStart),
    "ms",
    "| total:",
    Math.round(performance.now() - galleryStart),
    "ms"
  );

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      console.log(
        "[VMFG] gallery reached next paint:",
        Math.round(performance.now() - galleryStart),
        "ms"
      );
    });
  });
  
      if (shouldScroll && window.matchMedia("(max-width: 749px)").matches) {
  const target = mediaWrapper.querySelector(".vmfg-main") || mediaWrapper;
  requestAnimationFrame(() => {
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  });
}
    }

    const initial = getVariantId();
    if (initial) render(initial);

    document.addEventListener("variantChange", (event) => {
      const variant = event?.detail?.variant;
      if (!variant?.id) return;
      if (String(event?.detail?.productId) !== String(sectionEl.dataset.productId)) return;
      render(variant.id);
    });

    sectionEl.addEventListener("change", (e) => {
      if (e.target && e.target.name === "id") render(e.target.value);
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("product-info[id^='MainProduct-']").forEach(init);
    setupVmfgZoom();
  });
})();